import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Head from 'next/head';
import { Button } from '../../components/Button.js';

import { Box } from '@chakra-ui/react';

import { motion } from 'framer-motion';

import Image from 'next/image';

import { servicesInnerArticleData } from '../../data/servicesPageData';
import { VisuallyHidden } from '@chakra-ui/react';

const imageLoader = require('../../loader.js');

const tabs = [
  { label: 'Design Services', link: 'designServices' },
  { label: 'Digital Marketing', link: 'digitalMarketing' },
  { label: 'Software Development', link: 'softwareDevelopment' },
  { label: 'Mobile Development', link: 'mobileDevelopment' },
  { label: 'DevOps', link: 'devops' },
  { label: 'Staff Augmentation', link: 'staffAugmentation' },
];

const sectionTitleVariants = {
  hidden: {
    y: -100,
  },
  visible: {
    y: 0,
    transition: {
      duration: 0.5,
      repeat: 0,
    },
  },
};

const sectionImageVariants = {
  hidden: {
    x: -100,
  },
  visible: {
    x: 0,
    transition: {
      duration: 0.5,
      repeat: 0,
    },
  },
};

export const getStaticProps = async () => {
  return {
    props: {
      servicesInnerArticleData,
    },
  };
};

const innerNavbarContainer = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const innerNavbarItem = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
};

export default function Services({ servicesInnerArticleData }) {
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const elementTargets = document.querySelectorAll('.servicesInnerArticle');

    elementTargets.forEach((item) => {
      if (window.scrollY > item.offsetTop - window.innerHeight / 2) {
        tabs.forEach((tab) => {
          if (tab.link === item.id) {
            setSelectedTab(tab);
          }
        });
      }
    });
  };

  return (
    <>
      <Head>
        <title>Services | drive</title>
      </Head>
      <section className={'servicesHero'}>
        <div className="section-wrapper flex-column justify-center h-100">
          <h1>What We Do Best!</h1>
          <p>Check out our full list of services.</p>
          <div>
            <a href="#inner-content" className="btn-with-arrow-light-down">
              What We Offer
            </a>
          </div>
        </div>
        <div className="servicesHero-overlay" />
      </section>

      <section id="inner-content" className={'innerNavSection'}>
        {/* Inner navbar */}
        <div className="inner-navbar-wrapper">
          <div className="innerNavContainer">
            <motion.div
              className="inner-nav"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={innerNavbarContainer}
            >
              {tabs.map((item, index) => {
                return (
                  <motion.a
                    key={index}
                    href={`#${item.link}`}
                    className={
                      item === selectedTab
                        ? 'inner-nav-item selected'
                        : 'inner-nav-item'
                    }
                    onClick={() => setSelectedTab(item)}
                    variants={innerNavbarItem}
                  >
                    <p>{item.label}</p>
                    {item === selectedTab ? (
                      <motion.div className="underline" layoutId="underline" />
                    ) : null}
                  </motion.a>
                );
              })}
            </motion.div>
          </div>
        </div>
        {/* end of inner navbar */}

        {servicesInnerArticleData &&
          servicesInnerArticleData.map(
            ({
              sectionId,
              articleMainTitle,
              articleText,
              sublinks,
              techIcons,
            }) => {
              return (
                <div
                  id={sectionId}
                  className={
                    'servicesInnerArticle flex align-center justify-center'
                  }
                  key={sectionId}
                >
                  <div
                    className={'section-wrapper'}
                    style={{ position: 'relative' }}
                  >
                    <div className={'designServicesText'}>
                      <motion.h1
                        initial="hidden"
                        whileInView={'visible'}
                        viewport={{ once: true }}
                        variants={sectionTitleVariants}
                      >
                        {articleMainTitle}
                      </motion.h1>
                      <p>{articleText}</p>
                      <div className={'infoCardSublinkContainer'}>
                        {sublinks &&
                          sublinks.map(({ href, title }, index) => (
                            <div key={index} className={'infoCardSublink'}>
                              <Link href={href}>
                                <a className={'infoCardSublinkText'}>{title}</a>
                              </Link>
                            </div>
                          ))}
                      </div>
                      <div>
                        <div className={'infoCardTechContainer'}>
                          {techIcons &&
                            techIcons.map(({ src, alt }, index) => (
                              <div key={index} className={'techIcon'}>
                                <Image
                                  width={40}
                                  height={40}
                                  src={`/${src}`}
                                  alt={`${alt} logo`}
                                />
                              </div>
                            ))}
                        </div>
                        <div className="ctaButtonContainer">
                          <Button
                            linkTo={'/contact-us'}
                            title="Get In Touch"
                            className={'btn glowing-border'}
                          />
                          <Button
                            linkTo={'/services/design-services'}
                            title={`View ${articleMainTitle} Details`}
                            className={'btn-with-arrow'}
                          />
                        </div>
                      </div>
                    </div>

                    <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      width="50%"
                      height="50%"
                      transform={'translate(-50%, -50%)'}
                      opacity="0.4"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      variants={sectionImageVariants}
                    >
                      <Image
                        layout="fill"
                        objectFit="contain"
                        src={'/services-design.png'}
                        alt="Branding & Design"
                      />
                    </Box>
                  </div>
                </div>
              );
            }
          )}
      </section>
    </>
  );
}
